import { fetchy } from '@bridebook/web/lib/fetchy';
import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';
import { useQuery } from '@tanstack/react-query';
import {
  ISupplierCalendar,
  ISupplierCalendarType,
} from '@bridebook/models/source/models/Suppliers/Calendars.types';

const CALENDARS_QUERY_CACHE_TIME = toMillis(5, 'min');

export const getCalendarsQueryKey = (supplierId: string) => ['calendars', supplierId];

export type Calendar = Pick<
  ISupplierCalendar,
  'id' | 'type' | 'location' | 'description' | 'questions' | 'title' | 'duration' | 'maxAdvance'
>;

/**
 * Hook to get all the calendars for a supplier using react query
 */
export const useCalendarsQuery = (supplierId: string, options?: { enabled?: boolean }) => {
  const { data, isLoading, error } = useQuery(
    getCalendarsQueryKey(supplierId),
    async () =>
      await fetchy().authenticated.get('/api/supplier/[id]/calendars', {
        id: supplierId,
      }),
    {
      enabled: !!supplierId && options?.enabled !== false,
      refetchOnWindowFocus: false,
      cacheTime: CALENDARS_QUERY_CACHE_TIME,
      staleTime: CALENDARS_QUERY_CACHE_TIME,
    },
  );

  return {
    calendars: data || [],
    showroundCalendar: data?.find((calendar) => calendar.type === ISupplierCalendarType.Showround),
    openDayCalendar: data?.find((calendar) => calendar.type === ISupplierCalendarType.OpenDay),
    isLoading,
    error,
  };
};
